<template>
    <div class="newsList"  @click="getNewsDetailInfo(newsContent.news_id)">
        <div class="news_img">
            <img :src="weburl+newsContent.image" alt="">
        </div>
        <div class="news_word">
            <h1>{{newsContent.title}}</h1>
            <p><span>{{newsContent.add_time}}</span><span>浏览次数：{{newsContent.click}}</span></p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "newsList",
        props:['newsContent'],
        created:function () {
            // console.log(this.newsContent);
        },
        methods:{
           getNewsDetailInfo (id) {
               this.$router.push({path: `/newsDetail/${id}`})
           }
        },
        computed:{
            weburl: function () {
                return this.$store.state.weburl;
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../assets/less/common.less';
    .newsList {
        width: 93%;
        .border-radius(10px);
        margin: 0 auto 20px;
        background: @font-primary;
        .box-shadow;
        .news_img {
            width: @width;
            .border-radius(10px 10px 0 0);
            img {
                .img;
                .border-radius(10px 10px 0 0);
            }
        }
        .news_word {
            .box-sizing;
            padding: 10px;
            h1 {
                font-size: @font + .1;
                margin-bottom: 10px;
                line-height: 24px;
            }
            p {
                color:tint(@word,50%);
                font-size: .4rem;
                height: 20px;
                line-height: 20px;
                span {
                    &:last-child{
                        float: right;
                    }

                }
            }

        }
    }

</style>
